module.exports = __webpack_public_path__ + "img/102045.6cde99cf.png";